import styled from "styled-components";

const BenefitsSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 55px;
  padding: 5px;
`;

export default BenefitsSc;
